import { render, staticRenderFns } from "./rightSide.vue?vue&type=template&id=2edee71a&scoped=true&"
import script from "./rightSide.vue?vue&type=script&lang=js&"
export * from "./rightSide.vue?vue&type=script&lang=js&"
import style0 from "./rightSide.vue?vue&type=style&index=0&id=2edee71a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edee71a",
  null
  
)

export default component.exports